<template>
  <section class="container news-detail">
    <div class="row">
      <article class="col-xs-12">
        <v-heading :level="1">{{ newsItem.Title }}</v-heading>
        <div>{{ newsItem.PublishDate }}</div>
        <div class="newsbody" v-html="newsItem.Body"></div>
      </article>
    </div>
  </section>
</template>

<script>
  import moment from 'moment'
  import { mapGetters } from 'vuex'
  import store from '@/store'
  import router from '@/router'
  
  export default {
    name: 'v-news-detail',
    computed: {
      ...mapGetters({
        newsItem: 'news/getNewsItem'
      })
    },
    async created () {
      await store.dispatch('news/fetchNewsItem', router.currentRoute.params.id)
    },
    methods: {
      moment (...args) {
        return moment(...args)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .news-detail{
    h1.heading {
      font-size: type-scale(3);
      line-height: line-height(2);
      font-weight: 900;
      color: $teal-darkest;
      margin: 0 0 .4rem;
    }
    .newsbody {
      font-size: type-scale(0);
      line-height: line-height(2);
      color: $gray-darkest;
      margin: 1rem 0 .4rem;
      a {
        font-weight: 900;
        color: $teal-darkest;
      }
    }
    time {
      color: $gray;
      font-size: type-scale(0);
      line-height: line-height(0);
      margin-top: 0;
    }
  }
</style>
